import { useMutation } from '@tanstack/react-query';
import { lectureLeaveFriction } from 'src/constants/constants';
import { UNLEASH_ANAYTICS_PAYLOAD } from 'src/constants/type';
import { Client } from 'src/lib/api-client';
import { checkUnleashFeatureFetcher } from 'src/lib/fetchers/lecture-leave-friction';

const handleAnalytics = (payload: UNLEASH_ANAYTICS_PAYLOAD) => {
  const BASE_URL = process.env.REACT_APP_ANALYTICS_API_BASE_URL;

  Client.post(`${BASE_URL}core-analytics/universal/experiments/record`, payload, {
    endPointWithBaseUrl: true,
  });
};

const useCheckUnleashFeature = () => {
  const { data, error, mutate, isLoading } = useMutation<
    UnleashFeature[],
    Error,
    { featureName: string[] }
  >(checkUnleashFeatureFetcher, {
    onSuccess: (data) => {
      if (data && data.length > 0) {
        data.forEach((feature) => {
          const analyticsPayload: UNLEASH_ANAYTICS_PAYLOAD = {
            experimentName: feature.featureName,
            variantName: feature.variantName,
            featureEnabled: feature.enabled,
          };
          if (feature.featureName === lectureLeaveFriction && feature.enabled) {
            handleAnalytics(analyticsPayload);
          }
        });
      }
    },
  });

  return {
    checkUnleashFeature: mutate,
    data,
    error,
    isLoading,
  };
};

interface UnleashFeaturePayload {
  type: string;
  value: string;
}

export interface UnleashFeature {
  enabled: boolean;
  variantName: string;
  payload: UnleashFeaturePayload;
  featureName: string;
}

export default useCheckUnleashFeature;
